import InformationDrawer from "../../molecules/InformationDrawer";
import RepairBonusDrawerContent from "./RepairBonusDrawerContent";
import React from "react";
import { styled, useMediaQuery, useTheme } from "@material-ui/core";
import InfoOutline from "./assets/infoOutline.svg";
import Box from "@material-ui/core/Box";

const UnderlinedButton = styled("u")(({ theme }) => ({
  paddingLeft: theme.spacing(1),
}));

const FixedMarginInfoSvg = styled(InfoOutline)({
  verticalAlign: "top",
});

const RepairBonusDrawer = ({ displayWithInfoIcon = false, linkText = "" }) => {
  const theme = useTheme();
  const isUnderSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  let triggerButton;
  if (displayWithInfoIcon && linkText) {
    triggerButton = (
      <Box display="flex">
        <FixedMarginInfoSvg />
        <UnderlinedButton>{linkText}</UnderlinedButton>
      </Box>
    );
  } else if (displayWithInfoIcon) {
    triggerButton = <FixedMarginInfoSvg />;
  } else {
    triggerButton = <UnderlinedButton>{linkText}</UnderlinedButton>;
  }

  return (
    <InformationDrawer
      anchor={isUnderSmallScreen ? "bottom" : "right"}
      width={isUnderSmallScreen ? "100%" : "470px"}
      title="À propos du Bonus Réparation"
      button={triggerButton}
    >
      {() => <RepairBonusDrawerContent />}
    </InformationDrawer>
  );
};

export default RepairBonusDrawer;
